export default (dateEnd, dateNow, redirectionDateEnd) => ({
  dateEnd: null,
  redirectionDateEnd: null,
  intervalId: null,
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00',
  isVisible: false,
  init() {
    this.dateEnd = Number(dateEnd);
    this.dateNow = Number(dateNow);
    this.redirectionDateEnd = String(redirectionDateEnd).replace(/^["']|["']$/g, '').trim();

    if (Number.isNaN(this.dateEnd) || Number.isNaN(this.dateNow)) {
      return;
    }

    this.updateCountdown();
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
  },

  destroy() {
    clearInterval(this.intervalId);
  },

  updateCountdown() {
    this.dateNow = this.dateNow + 1000;

    const diff = this.dateEnd - this.dateNow;

    this.days = Math.floor(diff / (1000 * 60 * 60 * 24));
    this.hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    this.minutes = Math.floor((diff / (1000 * 60)) % 60);
    this.seconds = Math.floor((diff / 1000) % 60);

    this.days = this.formatTime(this.days);
    this.hours = this.formatTime(this.hours);
    this.minutes = this.formatTime(this.minutes);
    this.seconds = this.formatTime(this.seconds);

    this.isVisible = true;

    if (diff <= 0) {
      clearInterval(this.intervalId);

      this.days = "00";
      this.hours = "00";
      this.minutes = "00";
      this.seconds = "00";

      window.location.replace(this.redirectionDateEnd);
    }
  },

  formatTime(value) {
    return String(value).padStart(2, '0');
  }
});
